import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ICustomer } from '../../../../shared/models';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { StorageManagerService } from '../../../../shared/services';
import { Utilities } from '../../../../shared/services/utilities';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
    standalone: false
})
export class NavMenuComponent implements OnInit, OnDestroy, AfterViewInit {
  // some of the variables are getting set from the parent components.
  // please don't remove any variables.
  loggedIn: boolean;
  // isExpanded: boolean;
  hasCurrentCustomer = false;
  editCompanyMenu = false;
  editContactMenu = false;
  editLLFormMenu = false;
  editLCRFormMenu = false;
  editERFormMenu = false;
  editBusinessCategoryMenu = false;
  editOrdersMenu = false;
  ordersFormMenu = false;
  hcValidationFormMenu = false;
  editBNCCFormMenu = false;
  submissionMenu = false;
  ingestBNCC = false;
  ingestPLRSPL = false;
  substanceLookup = false;
  splIngestLLForm = false;
  splViewLLForm = false;
  selectedCustomer: string;
  subscription: Subscription;
  userData: any;
  isAuthorized: boolean;
  customers: any[];
  fields: Object = { text: 'customerName', value: 'customerId' };
  ddwHeight = '220px';
  ddwWidth = '500px';
  drpWidth = '350px';
  customerId: number;
  sub: Subscription;
  toggleClientDropdownState: boolean;
  customersLoading = true;
  defaultHomepageLink = ''; // controlled by app.component

  @Input() currentCustomer: ICustomer;
  @Input() userName: string;
  @Input() email: string;
  @Input() permissionsSet: string[];
  @Input() dataScopes: any;
  @Input() customerSelectionEnabled = true;
  @Input() set areCustomersLoading(value: boolean) {
    this.customersLoading = value;
  }

  @Output() changedCustomerEmitter = new EventEmitter<string>();

  height = '220px';
  waterMark = 'Select a health authority';

  @ViewChild('switchCustomersddw')
    switchCustomersddw: DropDownListComponent;

  dataSourceApi: any;
  accessPermissions: any;
  dataScopeName: string;
  dataScope: string;
  dataScopeId: number;
  language = 'English';
  dataSource: any[] = [];

  public dataScopeFields: Object = { text: 'name', value: 'id' };

  constructor(private authenticationService: AuthenticationService,
    private storageManagerService: StorageManagerService,
    private utilService: Utilities,
    private toastr: ToastrService) {
  }

  ngOnInit(): void {
    // Drive loggedIn from the actual authentication state so the Sign Out link is available whenever the
    // user is authenticated - even if the page bootstrap stalls before site-layout sets it (e.g. an
    // unmapped SSO user stuck loading). The *ngIf="loggedIn" gate stays, so Sign Out is still correctly
    // hidden when NOT authenticated (this nav also renders on the unauthenticated 404 page).
    this.authenticationService.getIsAuthorized().subscribe(isAuthorized => { this.loggedIn = isAuthorized; });
  }

  skipNavigation(e) {
    const type = e.type;

    if (type === 'click' || (type === 'keydown' && (e.which === 13 || e.keyCode === 13))) {
      const main = document.getElementById('main-heading');

      if (main) {
        main.focus();
      }

      e.preventDefault();
      e.stopPropagation();
    }
  }
  logout() {
    const accessPermissions = this.storageManagerService.read('accessPermissions');

    if (accessPermissions) {
      this.authenticationService.captureLogoutEvent(this.email)
        .subscribe(res => {
          this.authenticationService.logout();
        },
        error => {
          this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
        });
    } else {
      this.authenticationService.logout();
    }
  }

  ngAfterViewInit(): void {
    if (this.customerSelectionEnabled) {
      // listen for the status change to determine if we need to disable the client dropdown
      this.sub = this.utilService.toggoleClientDropdownState$.subscribe(
        status => this.toggleClientDropdownState = status,
      );

      const sessionCustomers = this.storageManagerService.read('eligibleCustomers');

      const sessionCurrentCustomer = this.storageManagerService.read('currentCustomer');

      this.userData = this.storageManagerService.read('userData');

      if (sessionCustomers && sessionCurrentCustomer) {
        this.customers = sessionCustomers;
        this.currentCustomer = !this.currentCustomer ? (typeof sessionCurrentCustomer === 'object' ? sessionCurrentCustomer : JSON.parse(sessionCurrentCustomer)) : this.currentCustomer;

        this.switchCustomersddw.value = this.currentCustomer.customerId;
        this.customersLoading = false;

      } else {
        if (sessionCustomers) {
          this.customers = sessionCustomers;
          this.customersLoading = false;
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  switchClient(event) {
    let changedCustomerId: number;
    const customers = this.storageManagerService.read('eligibleCustomers');

    if (event && event.itemData) {
      changedCustomerId = event.itemData.customerId;
    } else {
      const sessionCustomerStr = this.storageManagerService.read('currentCustomer');

      if (sessionCustomerStr) {
        const currentCustomer = typeof sessionCustomerStr === 'object' ? sessionCustomerStr : JSON.parse(sessionCustomerStr);

        if (currentCustomer) {
          changedCustomerId = currentCustomer.customerId;
        }
      }
    }

    const changedCustomer = customers.find(c => c['customerId'] === changedCustomerId);

    if (changedCustomer) {
      this.changedCustomerEmitter.emit(changedCustomer);
    }
  }
}
